<template>
  <div>
    <div class="section !py-0">
      <div
        class="container py-4 tablet:py-6 border-b border-b-border flex items-center"
      >
        <Logo top="Error" color="primary" bottom="Zürich, Switzerland" />
      </div>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>
